import React, { useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FiTrash } from 'react-icons/fi';
import { Box, Button, Flex } from 'rebass';

import { withBrandingDetailsLayout } from 'layouts/BrandingDetailsLayout';
import H2 from 'components/H2';
import { SideNavLayout } from 'layouts/SideNavLayout';
import { BrandingForm } from 'components/BrandingForm';
import useMutation from 'hooks/useMutation';
import services from 'services/services';
import { useToastHelper } from 'hooks/useToastHelper';
import { DeleteBrandingModal } from 'components/DeleteBrandingModal';

export const BrandingPage = withBrandingDetailsLayout(
    /**
     * @param {{ account: any }} auth
     */
    ({ auth }) => {
        const { brandingId } = useParams();
        const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
        const history = useHistory();
        const { addErrorToast, addSuccessToast } = useToastHelper();
        const sections = useRef({});
        const { mutate: deleteBranding, isLoading } = useMutation({
            mutationFn: () => services.deleteBranding(brandingId),
            onSuccess: () => {
                addSuccessToast('Branding deleted');
                history.push('/settings/brandings');
            },
            onError: (_, errorMessage) => addErrorToast(errorMessage)
        });

        return (
            <SideNavLayout
                sections={[
                    {
                        id: 'general',
                        ref: sections.current.general,
                        label: 'General',
                        display: true
                    },
                    {
                        id: 'danger-zone',
                        ref: sections.current.dangerZone,
                        label: 'Danger Zone',
                        display: true
                    }
                ]}
            >
                <Box
                    id="general"
                    ref={ref => (sections.current.general = ref)}
                    className="form-wrapper2  form-wrapper2-first"
                >
                    <Flex className="settings-header">
                        <Box>
                            <H2>General</H2>
                            <Box className="form-section-information">
                                <span>
                                    The logo will be used as the header in emails and screeners. Primary and secondary
                                    colors will be used for buttons and links.{' '}
                                    <a
                                        href="https://help.dscout.com/hc/en-us/articles/37094273000852"
                                        target="_blank"
                                        className="help-question"
                                    >
                                        ?
                                    </a>
                                </span>
                            </Box>
                        </Box>
                    </Flex>
                    <BrandingForm brandingId={brandingId} account={auth.account} />
                </Box>
                <Box
                    id="danger-zone"
                    ref={ref => (sections.current.dangerZone = ref)}
                    className="form-wrapper2 form-wrapper2-border"
                >
                    <Box className="settings-header">
                        <H2>Danger Zone</H2>
                        <Box className="form-section-information">Permanently delete this branding.</Box>
                    </Box>
                    <Box className="form-data">
                        <Button
                            type="button"
                            variant="danger"
                            disabled={isLoading}
                            onClick={() => setIsDeleteModalOpen(true)}
                        >
                            <FiTrash /> Delete branding
                        </Button>
                    </Box>
                </Box>
                <DeleteBrandingModal
                    isOpen={isDeleteModalOpen}
                    onClose={() => setIsDeleteModalOpen(false)}
                    onDelete={deleteBranding}
                />
            </SideNavLayout>
        );
    }
);
